/* unplugin-vue-components disabled */import { render } from "./PermissionTree.vue?vue&type=template&id=1a6458d7&scoped=true&ts=true"
import script from "./PermissionTree.vue?vue&type=script&lang=ts"
export * from "./PermissionTree.vue?vue&type=script&lang=ts"

import "./PermissionTree.vue?vue&type=style&index=0&id=1a6458d7&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6458d7"]])

export default __exports__